import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

const UnorderedList = ({ color = colors.actionMinor[500], ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
        <path
            d="M3.118 13.648c1.38 0 2.493 1.114 2.493 2.493s-1.114 2.493-2.493 2.493c-1.38 0-2.493-1.114-2.493-2.493s1.114-2.493 2.493-2.493zM3.118 3.675c1.38 0 2.493 1.114 2.493 2.493s-1.114 2.493-2.493 2.493c-1.38 0-2.493-1.114-2.493-2.493s1.114-2.493 2.493-2.493zM3.118 23.904c1.23 0 2.211 0.997 2.211 2.211s-0.997 2.211-2.211 2.211c-1.213 0-2.211-0.997-2.211-2.211s0.981-2.211 2.211-2.211zM8.104 27.777v-3.325h23.272v3.325h-23.272zM8.104 17.804v-3.325h23.272v3.325h-23.272zM8.104 4.506h23.272v3.324h-23.272v-3.325z"
            fill={color}
        />
    </svg>
);

export default React.memo(UnorderedList);
